import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export function PageContainer({
	children,
	className,
}: {
	children: ReactNode;
	className?: string;
}) {
	return (
		<div className={cn("fade-up mx-auto w-full min-w-0 max-w-workspace", className)}>
			{children}
		</div>
	);
}
